import React from 'react';
import {Box, Center, Image, SimpleGrid, Text,} from '@chakra-ui/react';
import {useSetRecoilState} from 'recoil';
import {selectedCompany} from '../company-detail';
import {AnimatePresence, motion} from 'framer-motion';
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";

const MotionedSimpleGrid = motion(SimpleGrid);
const MotionedBox = motion(Box);

const PortfolioListGridView = ({companies}) => {
    const navigate = useNavigate();
    const params = useParams()
    const setCompanyDetail = useSetRecoilState(selectedCompany);
    return (
        <>
            <MotionedSimpleGrid
                width="100%"
                maxW="100%"
                minW="100%"
                mx={0}
                columns={[1, 1, 3, 4, 4]}
                spacingX="10px"
                spacingY="20px"
            >
                <AnimatePresence>
                    {companies?.map((item, index) => (
                        <MotionedBox
                            initial={{opacity: 0}}
                            animate={{opacity: 1}}
                            exit={{opacity: 0}}
                            whileHover={{scale: 1.05}}
                            whileTap={{scale: 0.95}}
                            transition={{duration: 0.4}}
                            layout
                            height={'254'}
                            key={item.id}
                        >
                            <CompanyItem {...item} setCompanyDetail={setCompanyDetail} params={params} index={index}/>
                        </MotionedBox>
                    ))}
                </AnimatePresence>
            </MotionedSimpleGrid>
        </>
    );
};

const CompanyItem = (props) => {
    const {company_logo, company_name, sector, setCompanyDetail, params, index, slug, sector_slug} = props;
    const navigate = useNavigate();
    const location = useLocation();
    return (
        <>
            <Center
                mb={'0.625rem'}
                height={'200'}
                bg={'white'}
                overflow="hidden"
                _hover={{
                    backgroundColor: 'brand.700',
                    '& img': {
                        filter: 'grayscale(1) invert(1)',
                        mixBlendMode: 'screen',
                        objectFit: 'contain',
                        position: 'relative',
                    },
                }}
            >
                <Image src={company_logo} alt={`${company_name}-logo`} maxW="220px" width={`calc(100% - 60px)`} onClick={() => {
                    setCompanyDetail(index)
                    navigate(`/teammember/${params.slug}/${slug}`, {
                        state: {
                            from: location.pathname
                        }
                    });
                }}/>
            </Center>
            <Box as={Link}
                 {...Object.assign(
                     {
                         to: sector ? `/companies?sector=${sector_slug}` : '/companies',
                     },
                 )}
                 state={{comingFrom: 'nav'}}
                 >
                <Text
                    textTransform={'uppercase'}
                    fontWeight={'semibold'}
                    fontSize={'xs'}
                    lineHeight={'4'}
                    textAlign={'center'}
                    mt={'7px'}
                >
                    {sector}
                </Text>
            </Box>
        </>
    );
};

export default PortfolioListGridView;
